import React from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";

const Products = (props) => {

    const type = props.match.params.type;

    return (
        <div>
            <Header />
            <div id="content-header">
                <div className="container">
                    <h1 className="text-uppercase">{type}</h1>
                    <p>Train Harder. Move better. Live stronger. Explore our collection of high performance t-shirts designed for ultimate comfort, breathability and durability-whether you are hiding the gym taking ont he day.</p>
                </div>
            </div>

            <div className="container mt-5 mb-5" id="product">
                <h5 id="tx-title">SHOP BY COLLECTION</h5>
                <div className="row">
                    <div className="col-12 col-md-3" onClick={() => props.history.push('/product-detail/12345')}>
                        <img className="img-fluid mb-2" src="assets/images/sample-1.jpg" alt="" />
                        <h4>Basic Denise</h4>
                        <p>ZMW89.00</p>
                        <button className="btn btn-primary btn-cart btn-block">ADD TO CART</button>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Products;
